"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iMappedUserGroups = exports.iMappedCategory = exports.iUserGroup = exports._Notifications = exports.iUserGroupType = exports.iUserGroupIdAlias = void 0;
const t = require("io-ts");
const User = require("./user");
const Feature = require("./feature");
exports.iUserGroupIdAlias = t.number;
exports.iUserGroupType = t.keyof({
    ExternalUserGroup: null,
    ProjectAdminUserGroup: null,
    CustomerAdminUserGroup: null,
    CustomerVisibilityUserGroup: null,
    SuperAdminUserGroup: null,
    CustomerCategoryUserGroup: null,
    CustomerUserGroup: null,
    NormalUserGroup: null,
    SalesmanUserGroup: null,
    CategoryUserGroup: null,
    LightAdminCategoryUserGroup: null,
    LightAdminUserGroup: null,
    SokoBidAdminUserGroup: null,
    SokoBidCategoryUserGroup: null,
    ParticipantUserGroup: null,
    SokoBidUserGroup: null,
    ListableUserGroup: null,
    WorksiteDiaryUserGroup: null,
    TRMVRUserGroup: null,
    UserProfileTRMVREmployer: null,
    UserProfileTRMVREmployee: null,
    UserProfileTRMVRPreview: null,
    UserProfileWorksiteDiaryMaster: null,
    UserProfileWorksiteDiarySupervisor: null,
    UserProfileWorksiteDiaryUser: null,
});
const __Notifications = t.interface({
    userUuid: t.string,
    emailNotification: t.boolean,
    userGroupUuid: t.string
});
exports._Notifications = t.clean(__Notifications);
const _iUserGroup = t.intersection([
    t.interface({
        name: t.string,
        id: t.number,
        uuid: t.string,
        type: exports.iUserGroupType,
    }),
    t.partial({
        description: t.union([t.string, t.null]),
        archive: t.boolean,
        categoryId: t.number,
        categoryName: t.string,
        validSince: t.number,
        validUntil: t.number,
        members: t.array(User.iUser),
        features: t.array(Feature.iAvailableFeatures),
        permission: t.number,
        notifications: t.array(exports._Notifications),
        meterType: t.string,
        inviteRightsTo: t.array(t.number)
    })
]);
exports.iUserGroup = t.clean(_iUserGroup);
const _iMappedCategory = t.interface({
    category: exports.iUserGroup,
    groups: t.array(exports.iUserGroup)
});
exports.iMappedCategory = t.clean(_iMappedCategory);
const _iMappedUserGroups = t.intersection([
    t.partial({
        projectAdminGroup: exports.iUserGroup,
        features: t.array(exports.iMappedCategory)
    }),
    t.interface({
        categories: t.array(exports.iMappedCategory),
        customerGroups: t.array(exports.iUserGroup)
    })
]);
exports.iMappedUserGroups = t.clean(_iMappedUserGroups);
//# sourceMappingURL=userGroup.js.map